/**
 * Widget Client Bundle
 *
 * This file bundles external dependencies (marked.js, DOMPurify) for the widget
 * to avoid external CDN calls and improve GDPR/DSGVO compliance.
 *
 * The bundle is built during the widget-service build process and served
 * as a static asset from /static/widget-bundle.js
 */

import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Exponiert `marked` und `DOMPurify` als globale Browser-Variablen.
 * Das von `widget.service.ts` generierte iFrame-HTML referenziert diese Globals
 * zur Markdown-Verarbeitung und XSS-Bereinigung von Bot-Nachrichten.
 * Eintrittspunkt für `webpack.client.config.js` — erzeugt `/static/widget-bundle.js`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access -- Pattern A: window-Augmentation für Browser-Bundle; marked/DOMPurify werden als Globals exponiert, kein typsicheres window-Extension-Pattern im Client-Bundle-Kontext praktikabel
(window as any).marked = marked;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access -- Pattern A: s.o.
(window as any).DOMPurify = DOMPurify;

// Log successful initialization (helpful for debugging)
console.log('[Widget Bundle] Markdown libraries loaded successfully');
